import React from 'react';

import { useFooterInteractor } from './interactor';
import { FooterRouter } from './router';

export interface IProps {
  backgroundColor?: string;
}
export const Footer: React.FC<IProps> = ({ backgroundColor = '#FFFFFF' }) => {
  const interactor = useFooterInteractor();
  return (
    <FooterRouter
      interactor={interactor}
      backgroundColor={backgroundColor}
    />
  );
};
